import { useCallback, useEffect, useState } from 'react';
import { Modal, Tooltip, Typography, Spin, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { observer } from 'mobx-react';
import { useStore } from '../../hooks';

import './style.scss';

export interface PrivacyPolicyModalProps {
  isVisible: boolean;
  onClose?(): void;
  onAccept(): void;
}

export const PrivacyPolicyModal = observer(
  ({ isVisible, onClose, onAccept }: PrivacyPolicyModalProps) => {
    const [isAccepted, setIsAccepted] = useState<boolean>(false);

    const { privacyPolicyLinkLoader } = useStore();

    useEffect(() => {
      if (!privacyPolicyLinkLoader.value) privacyPolicyLinkLoader.load();
    }, []);

    const { error, isLoading, value } = privacyPolicyLinkLoader;

    const handleChange = useCallback((value: CheckboxChangeEvent) => {
      setIsAccepted(value.target.checked);
    }, []);

    return (
      <Modal
        title="Политика конфиденциальности"
        open={isVisible}
        onCancel={onClose}
        onOk={onAccept}
        okText="Согласен"
        cancelText="Назад"
        okButtonProps={{ disabled: !isAccepted }}
      >
        <div className="privacy-policy">
          <Checkbox checked={isAccepted} onChange={handleChange}>
            Согласие на сбор и обработку персональных данных в соответствии с
            Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»
          </Checkbox>

          <Typography.Paragraph className="privacy-policy__link">
            {error ? (
              <Tooltip title="Не удалось получить ссылку на политику конфиденциальности">
                <a className="privacy-policy__disabled-link">
                  Политика конфиденциальности
                </a>
              </Tooltip>
            ) : (
              <>
                <a
                  target="_blank"
                  rel={'noreferrer'}
                  href={value}
                  className={
                    isLoading ? 'privacy-policy__disabled-link' : undefined
                  }
                >
                  Политика конфиденциальности
                </a>
                {isLoading && (
                  <Spin size="small" className="privacy-policy__spin" />
                )}
              </>
            )}
          </Typography.Paragraph>
        </div>
      </Modal>
    );
  },
);
